import {CompositionFont} from '@dms/api/sales';

import {BOLD_FONT_WEIGHT, REGULAR_FONT_WEIGHT} from './toFontFacePatch';

export type FontFaceToggles = {isBold: boolean; isItalic: boolean};

/**
 * The uploaded face of `family` that matches the Bold and Italic toggles, or null when the family
 * has no such face. Each uploaded font is one face (one file the server renders), so bold or italic
 * text needs its own face.
 */
export const resolveFontFace = (
  fonts: CompositionFont[],
  family: string,
  toggles: FontFaceToggles
) =>
  fonts.find(
    (font) =>
      font.family === family &&
      font.weight === (toggles.isBold ? BOLD_FONT_WEIGHT : REGULAR_FONT_WEIGHT) &&
      font.style === (toggles.isItalic ? 'italic' : 'normal')
  ) ?? null;
